// =============== FIXED HEADER ===============
const header = document.querySelector("sticky-header");
window.addEventListener("scroll", function () {
  if (pageYOffset > 1) {
    header.classList.add("fixed");
  } else {
    header.classList.remove("fixed");
  }
});

// ========================== Add Common-Home Class On Body Tag ==========================
document.addEventListener('DOMContentLoaded', function() {
var heroElement = document.getElementById('tb-hero');
if (heroElement) {
  document.body.classList.add('common-home');
}
});


// ========================== BACK TO TOP ========================== 
$(window).scroll(function () {
  if ($(this).scrollTop() >= 50) {
    $('#return-to-top').fadeIn(200);
  } else {
    $('#return-to-top').fadeOut(200);
  }
});
$('#return-to-top').click(function () {
  $('body,html').animate({
    scrollTop: 0
  }, 500);
});


// ========================== MENU-CLICK HIDE MENU DROPDOWN ==========================
  $(document).ready(function() {
  $('.list-menu__item').on('click', function() {
    $('#Details-menu-drawer-container').removeAttr('open');
    $('.header__icon').attr('aria-expanded', 'false');
    $('body').removeClass('overflow-hidden-tablet');
    $('.menu-opening').removeClass('menu-opening');
  });
});

// ========================== TESTIMONIAL ==========================
$(document).ready(function() {
  var tb_review_cms = $("#TB-Testimonial-cms .owl-carousel").owlCarousel({
            margin: 30,
            nav: false,
            dots: true,
            responsive: {
                0: { items: 1 },
                576: {
                    items: 2,
                    margin: 15,
                },
                768: {
                    items: 2,
                    margin: 15,
                },
                992: { items: 3 },
                1300: { items: 4 }
            },
        });

  // ========================== benefit ==========================
  var benefit_cms = $("#TB-benefit-cms .owl-carousel").owlCarousel({
      items: 3,
      loop: false,
      nav: false,
      dots: true,
      margin: 60,
      responsive: {
          0: {
          items: 1,
          margin: 15,
              },
          576: {
          items: 1,
          margin: 15,
              },
          768: {
          items: 2,
          margin: 15,
              },
          1200: {
            items: 3,
            margin: 30,
          },
          1300: {
            items: 3,
            margin: 60,
          }
      },
  });

   // ========================== Social media ==========================
     $('#TB-instagram-cms .owl-carousel').owlCarousel({
            loop: true,
            dots: true,
            nav: false,
            autoplay: true,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
              autoWidth:true,
            responsive: {
                0: {
                    items: 1
                },
                480: {
                    items: 1
                },
                576: {
                    items: 2
                },
                768: {
                    items: 3
                },
                992: {
                    items: 4
                },
                1400: {
                    items: 5
                },
                1600: {
                    items: 6
                },
            }
        })


        var tb_service_cms = $("#tb-service-cms .tb-service-carousel").owlCarousel({
            margin: 30,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsive: {
                0: { items: 1 },
                576: { items: 2, margin: 15 },
                768: { items: 2, margin: 15 },
                992: { items: 3 },
                1200: { items: 4 }
            },
        });

});



// ========================== FOOTER TOGGLE ==========================
function footerToggle() {
    if ($(window).width() < 992) {
        $(".tb-footer-center .footer-col h5").addClass("toggle");
        $(".tb-footer-center .footer-col h5.toggle").unbind("click");
        var Accordions = function (el, multiple) {
            this.el = el || {};
            this.multiple = multiple || false;
            var link = this.el.find('.toggle');
            link.on('click', { el: this.el, multiple: this.multiple }, this.dropdown)
        }
        Accordions.prototype.dropdown = function (e) {
            var $el = e.data.el;
            $this = $(this),
                $next = $this.next();
            $next.slideToggle();
            $this.parent().toggleClass('active');
            if (!e.data.multiple) {
                $el.find('.tb-footer-center .footer-col').not($next).slideUp().parent().removeClass('active');
            };
        }
        var accordions = new Accordions($('.tb-footer-center .footer-col'), false);
    } else {
        $(".tb-footer-center .footer-col h5.toggle").unbind("click");
        $(".tb-footer-center .footer-col h5").removeClass('toggle');
    }
}
$(document).ready(function () { footerToggle(); });
$(window).resize(function () { footerToggle(); });




// ========================== INSPECT CLOSE ==========================
// Prevent Developer Tools, Right-Click, and Restricted Shortcuts
document.addEventListener('keydown', function(event) {
    if (
        event.keyCode === 123 || // F12
        (event.ctrlKey && event.shiftKey && (event.keyCode === 67 || event.keyCode === 99)) || // Ctrl+Shift+C or c
        (event.ctrlKey && event.shiftKey && (event.keyCode === 73 || event.keyCode === 105)) || // Ctrl+Shift+I or i
        (event.ctrlKey && event.shiftKey && (event.keyCode === 74 || event.keyCode === 106)) || // Ctrl+Shift+J or j
        (event.ctrlKey && event.keyCode === 85) || // Ctrl+U
        (event.ctrlKey && event.shiftKey && (event.keyCode === 77 || event.keyCode === 109)) || // Ctrl+Shift+M or m
        (event.ctrlKey && event.shiftKey && (event.keyCode === 69 || event.keyCode === 101)) || // Ctrl+Shift+E or e
        (event.ctrlKey && event.shiftKey && (event.keyCode === 84 || event.keyCode === 116)) || // Ctrl+Shift+T or t
        (event.ctrlKey && event.shiftKey && (event.keyCode === 88 || event.keyCode === 120)) || // Ctrl+Shift+X or x
        (event.ctrlKey && event.altKey && event.keyCode === 83) || // Ctrl+Alt+S
        (event.metaKey && event.shiftKey && event.keyCode === 80) || // Cmd+Shift+P (Mac)
        (event.ctrlKey && event.keyCode === 83) || // Ctrl+S
        (event.metaKey && event.keyCode === 83) // Cmd+S (Mac)
    ) {
        event.preventDefault();
    }
}, false);

// Prevent context menu
document.addEventListener('contextmenu', function(event) {
    event.preventDefault();
}, false);

// Prevent mouse actions
document.addEventListener('mousedown', function(event) {
    if (
        event.button === 2 || // Right-click
        (event.ctrlKey && event.button === 0) || // Ctrl+Left-click
        (event.metaKey && event.button === 0) // Cmd+Left-click on Mac
    ) {
        event.preventDefault();
    }
}, false);

// judme btn new class add
// Select the element with class .jdgm-write-rev-link inside #judgeme_product_reviews
const element = document.querySelector('#judgeme_product_reviews .jdgm-write-rev-link');

// Add a new class, for example 'new-class'
if (element) {
    element.classList.add('btn-secondary');
}


// Example: Prevent adding the loading class
const btn = document.querySelector('.product-form__submit.button.button--secondary.btn-secondary');

btn.addEventListener('click', function (e) {
  // Wait briefly for class to be added, then remove it
  setTimeout(() => {
    btn.classList.remove('loading');
  }, 0); // 0ms delay removes it instantly after it's added
});


